import L from "leaflet";
import { ajax } from "../../app/core/ajax";
import Map from "../../app/core/map/map";
import { defaultLatLong } from "../../app/core/util/util";
import { clone } from "../core/core";
import { bind, observable } from "../core/kendo";
import { ll, LocalizedLanguage } from "../core/ll";
import { emptyFn } from "../core/util";
import { updateEntity } from "../dataComponents/updateEntity";
import { popUp } from "./popUp";
import saveCoordinatesView from "./saveCoordinates.view";
import { toolTip } from "./toolTip";

var geoCode;
var siteLayer;
var marker;
var dragged;
var thisMap;

export function saveCoordinates(options) {
    options = options || {};

    options.condition = options.condition ? true : false;
    options.onConditionFailDiscard = (typeof options.onConditionFailDiscard === "undefined" ? true : options.onConditionFailDiscard);
    options.dirtyGeocode = true;
    options.save = options.save || emptyFn;
    options.discard = options.discard || emptyFn;
    options.always = options.always || emptyFn;
    options.afterPopUp = options.afterPopUp || emptyFn;

    if (options.condition) {
        options.observable.Confidence = 0;

        updateEntity({
            dto: options.observable,
            validator: null,
            entityType: "Site",
            showMessages: true,
            success: function (data) {
                var siteId = data.d.results;
                ajax({
                    type: "GET",
                    url: "ShipTo?$inlinecount=allpages&$expand=Site&$filter=Site/Id eq {0}&$select=Id,Latitude,Longitude,Confidence,Site/Id&$top=1".format(siteId)
                }).done(function (shipToData) {
                    var results = shipToData.d.results[0];
                    var shipToSiteId = results.Site[0].Id;
                    var loc = observable(results);
                    options.observable.Latitude = loc.Latitude;
                    options.observable.Longitude = loc.Longitude;
                    var locationUpdate = {
                        Id: shipToSiteId,
                        Latitude: loc.Latitude,
                        Longitude: loc.Longitude
                    };
                    options.save(locationUpdate);
                    var zoom = 13;

                    var geoPopUp = popUp({
                        id: "GeoPopUp",
                        title: ll("IsThisLocationCorrect"),
                        buttons: [
                            {
                                name: ll("Yes"),
                                id: "Yes",
                                className: "right",
                                clickEvent: function () {
                                    options.save(locationUpdate);
                                }
                            },
                            {
                                name: ll("Finish"),
                                id: "Finish",
                                className: "right hidden",
                                clickEvent: function (e) {
                                    var latlongId = e.target.id.toString();
                                    latlongId = latlongId.substring(0, 1 + latlongId.indexOf("_"));
                                    var latitude = $("#" + latlongId + "Latitude").data("kendoNumericTextBox").value() || 0;
                                    var longitude = $("#" + latlongId + "Longitude").data("kendoNumericTextBox").value() || 0;
                                    locationUpdate.Latitude = latitude;
                                    locationUpdate.Longitude = longitude;
                                    updateEntity({
                                        dto: locationUpdate,
                                        entityType: "Site",
                                        showMessages: true
                                    }).done(function (args) {
                                        options.save(locationUpdate);
                                    });
                                }
                            },
                            {
                                name: ll("ResetToGeoCodedValue"),
                                id: "Reset",
                                className: "left hidden",
                                clickEvent: function (e) {
                                    locationUpdate.Latitude = options.observable.Latitude;
                                    locationUpdate.Longitude = options.observable.Longitude;
                                    geoCode = true;

                                    geoPopUp.get("#Latitude").data("kendoNumericTextBox").value(options.observable.Latitude);
                                    geoPopUp.get("#Latitude").data("kendoNumericTextBox").trigger("change");

                                    geoPopUp.get("#Longitude").data("kendoNumericTextBox").value(options.observable.Longitude);
                                    geoPopUp.get("#Longitude").data("kendoNumericTextBox").trigger("change");
                                    e.preventDefault();
                                }
                            },
                            {
                                name: ll("No"),
                                id: "No",
                                className: "left",
                                clickEvent: function (e) {
                                    geoCode = true;
                                    noConf();
                                    e.preventDefault();
                                    options.always(locationUpdate);
                                }
                            },
                            {
                                name: ll("Cancel"),
                                id: "Cancel",
                                className: "left hidden",
                                clickEvent: function () {
                                    options.always(locationUpdate);
                                }
                            }
                        ]
                    });

                    var detailsGuts = saveCoordinatesView();
                    detailsGuts.options.zScreen = geoPopUp;
                    detailsGuts.render(geoPopUp.guts);

                    geoPopUp.get("#UserLatLong").hide();

                    var color = function () {
                        if (loc.Confidence >= 7) {
                            return "#b2dba1"; // Green
                        } else if (loc.Confidence >= 4.5) {
                            return "#f5e79e"; // Yellow
                        } else if (loc.Confidence >= 2.5) {
                            return "#ffab5c"; // Orange
                        } else {
                            return "#dca7a7"; // Red
                        }
                    };

                    toolTip({
                        alignX: "right",
                        alignY: "center",
                        alignTo: "target",
                        offsetX: 5,
                        selector: geoPopUp.get("#ConfidenceInfo").selector,
                        content: ll("ConfidenceMessage").format(loc.Confidence || 0)
                    });

                    geoPopUp.get("#Confidence").kendoLinearGauge({
                        pointer: {
                            value: loc.Confidence,
                            color: color()
                        },
                        scale: {
                            majorUnit: 1,
                            minorUnit: .5,
                            max: 10,
                            vertical: false,
                            ranges: [
                                {
                                    from: 6.5,
                                    to: 10,
                                    color: "#b2dba1"// Green
                                },
                                {
                                    from: 4.5,
                                    to: 6.5,
                                    color: "#f5e79e"// Yellow
                                },
                                {
                                    from: 2.5,
                                    to: 4.5,
                                    color: "#ffab5c"// Orange
                                },
                                {
                                    from: 0,
                                    to: 2.5,
                                    color: "#dca7a7"// Red
                                }
                            ]
                        }
                    });

                    var noConf = function () {
                        geoPopUp.get("#Latitude").enable();
                        geoPopUp.get("#Longitude").enable();
                        loc.set("Confidence", 0);

                        if (geoCode) {
                            siteLayer.removeLayer(marker);
                            marker = thisMap.createMarker({
                                latitude: loc.Latitude,
                                longitude: loc.Longitude,
                                className: "blank-marker",
                                draggable: true
                            });
                        } else {
                            marker.setLatLng(L.latLng(loc.Latitude, loc.Longitude));
                        }

                        marker.on("dragend", function () {
                            dragged = true;
                            var markerLatLng = marker.getLatLng();
                            loc.set("Latitude", markerLatLng.lat);
                            loc.set("Longitude", markerLatLng.lng);
                            dragged = false;
                        });

                        siteLayer.addLayer(marker);

                        geoCode = false;

                        geoPopUp.get("#No").hide();
                        geoPopUp.get("#Cancel").parents(".action-button-container").removeClass("hidden");
                        geoPopUp.get("#Reset").parents(".action-button-container").removeClass("hidden");
                        geoPopUp.get("#Yes").hide();
                        geoPopUp.get("#Finish").parents(".action-button-container").removeClass("hidden");
                    };

                    geoPopUp.get("#UseLink").tie("click", function () {
                        loc.set("Latitude", loc.UserLatitude);
                        loc.set("Longitude", loc.UserLongitude);

                        noConf();
                    });

                    if (loc.Latitude == 0 && loc.Longitude == 0) {
                        var defaultLatLng = defaultLatLong();
                        loc.Latitude = defaultLatLng[0];
                        loc.Longitude = defaultLatLng[1];
                    }

                    bind({ container: geoPopUp.container, bind: ".bind-label", data: LocalizedLanguage });
                    bind({ container: geoPopUp.container, bind: ".bind-value", data: loc });

                    var mapElement = geoPopUp.get("#Map");

                    thisMap = new Map({
                        id: mapElement[0].id,
                        stickyDefaultName: "SiteMap",
                        markerLayers: [{
                            label: "Sites",
                            type: "site"
                        }]
                    });

                    siteLayer = thisMap.getLayer("Sites");

                    var layerClickEvent = function (e) {
                        switch (e.layer.type) {
                            case "Customer":
                            case "Site":
                                var timeLineElem = $("#Appointment_" + e.layer.zData.Id),
                                    timeLineViewWrapper = $("#TimeLineViewWrapper");

                                // me.highlightEvent({
                                //     timeLineElem: timeLineElem,
                                //     timeLineViewWrapper: timeLineViewWrapper
                                // });
                                break;
                            case "Tech":
                                break;
                        }
                    };

                    siteLayer.on("click", layerClickEvent);

                    marker = thisMap.addMarker("Sites", {
                        latitude: loc.Latitude,
                        longitude: loc.Longitude,
                        className: "blank-marker"
                    });

                    var moveMarker = function () {
                        marker.setLatLng([loc.Latitude, loc.Longitude]);
                        thisMap.leafletMap.setView([loc.Latitude, loc.Longitude], zoom);
                    };

                    thisMap.leafletMap.on("zoomend", function () {
                        zoom = thisMap.leafletMap.getZoom();
                    });

                    loc.bind("change", function () {
                        if (!dragged) {
                            moveMarker();
                            bind({ container: geoPopUp.container, bind: ".bind-value", data: loc });
                        }
                    });

                    geoPopUp.get("#Latitude").data("kendoNumericTextBox").bind("spin", function () {
                        geoPopUp.get("#Latitude").blur();
                    });

                    geoPopUp.get("#Longitude").data("kendoNumericTextBox").bind("spin", function () {
                        geoPopUp.get("#Longitude").blur();
                    });

                    thisMap.leafletMap.setView([loc.Latitude, loc.Longitude], zoom);

                    if ((loc.Longitude == 0 && loc.Latitude == 0) || !loc.Confidence) {
                        noConf();
                        popUp({
                            id: "NoConfidence",
                            title: ll("Confidence"),
                            guts: "<div style='margin-left:5px; margin-top:20px; margin-bottom:20px'>" + ll("UnableToLocate") + "</div>",
                            width: 450,
                            buttons: [
                            {
                                name: ll("Ok")
                            }
                            ]
                        });
                    }

                    options.afterPopUp();
                });
            }
        });
    } else {
        if (options.onConditionFailDiscard) {
            options.discard();
        }
        options.always();
    }
}
